import { useState, useRef } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './MobileCarousel.css';
import { getSectionsInstitutions } from '../../services/getSectionsInstitutions';
import { useSelector } from 'react-redux';
import CarouselCard from '../V2/CarouselCard';
import { useRedirect } from '../../hooks/useRedirect';
// Translate
import { useTranslation } from 'react-i18next';

const MobileCarousel = ({
  visibleItems = 3,
  itemWidth = 190,
  itemHeight = 200,
  itemMargin = 8,
}) => {
  const { t } = useTranslation();
  const { redirect } = useRedirect();
  const { institutionCode, ebooksAccess } = useSelector(
    (state) => state.institution
  );

  const dataMetasearcher = getSectionsInstitutions(
    institutionCode,
    ebooksAccess
  )[0].data;
  const dataIndependient = getSectionsInstitutions(
    institutionCode,
    ebooksAccess
  )[1].data;
  const filterSectionsByTitle = (items) => {
    const wanted = [
      'Articles',
      'Dictionary',
      'GALE Resources',
      'Job Hunter',
      'Patents',
    ];
    return items.filter((item) => wanted.includes(item.title));
  };

  const data = [...dataMetasearcher, ...dataIndependient];
  const filteredSections = filterSectionsByTitle(data);

  const totalItems = filteredSections?.length;
  const step = itemWidth + itemMargin * 2;
  const maxTranslate = 0;
  const minTranslate = Math.min(visibleItems - totalItems, 0) * step;

  // current x offset in px
  const [position, setPosition] = useState(0);
  // refs to track drag
  const dragging = useRef(false);
  const startX = useRef(0);
  const startPos = useRef(0);

  // --- Handlers ---
  const handlePointerDown = (clientX) => {
    dragging.current = true;
    startX.current = clientX;
    startPos.current = position;
  };

  const handlePointerMove = (clientX) => {
    if (!dragging.current) return;
    const delta = clientX - startX.current;
    let next = startPos.current + delta;
    // clamp
    next = Math.max(minTranslate, Math.min(maxTranslate, next));
    setPosition(next);
  };

  const handlePointerUp = () => {
    dragging.current = false;
  };

  // Button nudges
  const prev = () => setPosition((p) => Math.min(p + step, maxTranslate));
  const next = () => setPosition((p) => Math.max(p - step, minTranslate));

  const sliderStyle = {
    display: 'flex',
    transform: `translateX(${position}px)`,
    transition: dragging.current ? 'none' : 'transform 0.3s ease',
  };
  const slideStyle = {
    flexShrink: 0,
    width: `${itemWidth}px`,
    height: `${itemHeight}px`,
    margin: `0 ${itemMargin}px`,
    boxSizing: 'border-box',
  };

  return (
    <div className='carousel-main-container my-4'>
      <div
        className='mobile-carousel-container'
        onMouseDown={(e) => handlePointerDown(e.clientX)}
        onMouseMove={(e) => handlePointerMove(e.clientX)}
        onMouseUp={handlePointerUp}
        onMouseLeave={handlePointerUp}
        onTouchStart={(e) => handlePointerDown(e.touches[0].clientX)}
        onTouchMove={(e) => handlePointerMove(e.touches[0].clientX)}
        onTouchEnd={handlePointerUp}
      >
        <div style={sliderStyle}>
          {filteredSections.map((section, i) => (
            <div
              key={i}
              style={slideStyle}
              onClick={() => redirect(section.route)}
            >
              <CarouselCard
                backgroundImage={section.bgImage}
                label={
                  t(section.title)
                }
              />
            </div>
          ))}
        </div>
      </div>

      <div className='carousel-btn-container'>
        <button
          onClick={prev}
          disabled={position >= maxTranslate}
          className='carousel-btn'
          style={{
            opacity: position >= maxTranslate ? 0.3 : 1,
          }}
          aria-label='Previous'
        >
          <FaChevronLeft />
        </button>

        <button
          onClick={next}
          disabled={position <= minTranslate}
          className='carousel-btn'
          style={{
            opacity: position <= minTranslate ? 0.3 : 1,
          }}
          aria-label='Next'
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default MobileCarousel;
